import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyVendor } from 'src/app/classes/models';
import {
  VSA_BYPASS_REASON_OPTIONS,
  VsaBypassReason
} from 'src/app/interfaces/vsa-bypass-reason';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-mark-vsa-signed-modal',
  templateUrl: './mark-vsa-signed-modal.component.html',
  styleUrl: './mark-vsa-signed-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MarkVsaSignedModalComponent implements OnInit {
  constructor(
    private activeModal: NgbActiveModal,
    private ToastService: ToastService,
    private UtilityService: UtilityService
  ) {}

  @Input() CompanyVendor?: CompanyVendor;

  readonly bypassReasonOptions = VSA_BYPASS_REASON_OPTIONS;

  form = new FormGroup({
    reason: new FormControl<VsaBypassReason | null>(null, {
      validators: [Validators.required]
    })
  });

  ngOnInit(): void {
    if (!this.CompanyVendor?.CompanyId || !this.CompanyVendor?.VendorId) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Cannot mark VSA as signed. Missing Client/Vendor info.',
        { returnError: true }
      );
    }
  }

  get selectedReason(): VsaBypassReason | null {
    return this.form.controls.reason.value;
  }

  get isClientWaiverSelected(): boolean {
    return this.selectedReason === 'CLIENT_WAIVER';
  }

  confirm(): void {
    const errors = this.UtilityService.generateValidationErrorsObject(
      this.form
    );

    if (errors) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Select a reason before continuing.',
        { returnError: true }
      );
    }

    const reason = this.form.controls.reason.value;

    if (!reason) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Select a reason before continuing.',
        { returnError: true }
      );
    }

    this.activeModal.close(reason);
  }

  close(): void {
    this.activeModal.dismiss();
  }
}
